import { render, staticRenderFns } from "./addEmployee.vue?vue&type=template&id=e31fd9be&scoped=true&"
import script from "./addEmployee.vue?vue&type=script&lang=ts&"
export * from "./addEmployee.vue?vue&type=script&lang=ts&"
import style0 from "./addEmployee.vue?vue&type=style&index=0&id=e31fd9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31fd9be",
  null
  
)

export default component.exports